import React from "react";
import omit from "@/utils/omit";
import { IconProps } from "../interface";

const IconCheckSimple = React.forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <svg
      ref={ref}
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="yfm-icon yfm-icon-check-simple"
      {...omit(props, ["className"])}
    >
      <path d="M20 6L9 17l-5-5" />
    </svg>
  )
);

IconCheckSimple.displayName = "IconCheckSimple";

export default IconCheckSimple;
